<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="d-flex justify-content-between align-items-center">
        <h1 class="mt-3">Manage Products</h1>
        <router-link class="btn btn-dark" :to="{name:'BookEdit', params: {productId: 0}}">Add Product</router-link>

        <!-- <button class="btn btn-dark">Nuevo</button> -->
        </div>
        <hr />

        <table v-if="this.ready" class="table table-striped table-compact">
          <thead>
            <tr>
              <th>Producto</th>
              <th>Descripción</th>
              <th>Stock</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="p in this.product" v-bind:key="p.id">
              <td>
                <router-link :to="`/admin/books/${p.id}`">{{
                  p.name
                }}</router-link>
              </td>
              <td>{{ this.formatoNumero(p.price) }} {{this.moneda}}</td>
              <td>{{ p.stock }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Security from './security';

// import Security from './security.js'

export default {
  name: "BooksAdmin",
  data() {
    return {
      product: {},
      ready: false,
      moneda: "lps",
    };
  },
  mounted() {
    // Security.requireToken();

    fetch(process.env.VUE_APP_API_URL + "/api/product/products/inventory/", Security.requestOptions(null, "GET"))
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          this.$emit("error", data.message);
        } else {
          this.product = data;
          console.log(data);
          this.ready = true;
        }
      });
  },
  methods:{
    formatoNumero(numero) {
      return new Intl.NumberFormat("en-US").format(numero)
    },
  }
};
</script>
